export default __webpack_public_path__ + "static/banner3-7b4587395f856e0479e74b4ccb74c8df.svg";